/*eslint-disable */
import root from '../_helpers/roots';
let loginurl = root.loginUrl.link;
let loginotpurl = root.loginOtpUrl.link;
let acuserurl = root.acUserUrl.link;
let userLoginDetailsURL = root.userLoginDetailsUrl.link;
let newUserRegisteredURL = root.newUserRegisteredUrl.link;
let newSignupedUserListURL = root.newSignupedUserListUrl.link;
import axios from 'axios';
import Vue from 'vue'
export default {
  state: {
    token: localStorage.getItem('token'),
    status: '',
    acUserDetailsState:'',
    signUpedUserListState:''
  },
  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },
    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = '';
      state.status = '';
    },
    AcUserDetailsM(state, value) {
      Vue.set(state, 'acUserDetailsState', value);
    },
    signUpedUserListMut(state, value) {
      Vue.set(state, 'signUpedUserListState', value);
    },
  },
  actions: {
    checkUserLoginDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(userLoginDetailsURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    checkLoginType(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginurl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    loginWithOtp(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginotpurl, payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.token);
            localStorage.setItem('LoginedUserID', response.data.data.user.id);
            localStorage.setItem('token', response.data.data.token);
            axios.defaults.headers.common['Authorization'] = "Token " + response.data.data.token;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    logout(context) {
      return new Promise((resolve, reject) => {
        console.log("User Logout Data")
        context.commit('authLogout');
        localStorage.removeItem('token');
        localStorage.removeItem('LoginedUserID');
        delete axios.defaults.headers.common['Authorization'];
        resolve();
      })
    },
    getAuthHeader() {
      return {
        'Authorization': 'Token ' + localStorage.getItem('token')
      }
    },
    // Get Data Well Task Details
    getAcUserDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(acuserurl, payload).then(res => {
              context.commit('AcUserDetailsM', res.data);
              resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    NewUserSignUpFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(newUserRegisteredURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getListOfSignupedUserFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(newSignupedUserListURL).then(
            (response) => {
              context.commit('signUpedUserListMut', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    isAuthenticated: state => !!state.token && !!localStorage.getItem('LoginedUserID'),
    authStatus: state => state.status,
    acUserDetailsStateGetters: state => state.acUserDetailsState,
    signUpedUsersListGetters: state => state.signUpedUserListState
  }
}
